export interface BreadcrumbOptions {
  showBreadcrumb: boolean;
  prop: string;
  listDescription: string;
  description: string;
}
